<template>
  <!-- 新增固件 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <!-- 车辆类别 -->
        <el-form-item
          :label="$t('pages.equipment.text5')"
          prop="bikeCategoryId"
        >
          <el-select
            v-model="ruleForm.bikeCategoryId"
            :placeholder="$t('public.text5')"
            @change="selectBikeCategory"
            :disabled="dialogStatus == 2"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车辆型号 -->
        <el-form-item :label="$t('pages.equipment.text6')" prop="bikeTypeId">
          <el-select
            v-model="ruleForm.bikeTypeId"
            :placeholder="$t('public.text5')"
            @change="selectBikeType"
            :disabled="dialogStatus == 2"
          >
            <el-option
              v-for="(item, index) in firmwareManagementListBikeType"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 固件类别 -->
        <el-form-item :label="$t('pages.equipment.text198')" prop="hwType">
          <el-select
            v-model="ruleForm.hwType"
            :placeholder="$t('public.text5')"
            @change="selectHwType"
            :disabled="dialogStatus == 2"
          >
            <el-option
              v-for="item in opeting"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 适配硬件版本 -->
        <el-form-item
          class="hwVersion"
          :label="$t('pages.equipment.text214')"
          prop="hwVersion"
        >
          <el-select
            v-model="ruleForm.hwVersion"
            :placeholder="$t('public.text5')"
            :disabled="dialogStatus == 2"
          >
            <el-option
              v-for="(item, index) in firmwareManagementListSuitableHwVersion"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 固件名称 -->
        <el-form-item
          :label="$t('pages.equipment.text200')"
          prop="firmwareName"
        >
          <el-input
            v-model="ruleForm.firmwareName"
            :disabled="dialogStatus == 2"
          ></el-input>
        </el-form-item>
        <!-- 固件版本 -->
        <el-form-item :label="$t('pages.equipment.text201')" prop="fwVersion">
          <el-input
            v-model="ruleForm.fwVersion"
            :disabled="dialogStatus == 2"
          ></el-input>
        </el-form-item>
        <!-- 固件说明 -->
        <el-form-item
          :label="$t('pages.equipment.text215')"
          prop="firmwareIntro"
        >
          <el-input
            type="textarea"
            rows="4"
            :placeholder="$t('public.text1')"
            v-model="ruleForm.firmwareIntro"
            :disabled="dialogStatus == 2"
            maxlength="50"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <!-- 固件文件 -->
        <el-form-item :label="$t('pages.equipment.text216')">
          <DiliUploadFile
            :limit="1"
            accept=".ble,.ccu,.bms,.dis,.ecu,.zip,.elk,.rgb,.ota,.bin"
            :fileList="fileList"
            @remove="remove"
            @success="success"
            :uploaDisabled="false"
            v-if="dialogStatus != 2"
          />
          <div class="firmware-content" v-if="dialogStatus == 2">
            <a
              :href="currentAgreement.filePath"
              :download="currentAgreement.fileName"
              >{{ currentAgreement.fileName }}</a
            >
            <span>{{ sizeReset(currentAgreement.fileSize) }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{
        dialogStatus == 2 ? $t("button.close") : $t("button.cancel")
      }}</el-button>
      <el-button v-if="dialogStatus != 2" type="primary" @click="submit">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { validateSpace } from "../../../../utils/util/test";
import DiliUploadFile from "../../../../components/pubilc/dilu-uploadfileA.vue";
import { mapState } from "vuex";
import { sizeReset } from "../../../../utils/util/validate";

export default {
  data() {
    return {
      ruleForm: {
        belongCustomerId: "", //客户id
        bikeCategoryId: "", //车辆类别
        bikeTypeId: "", //车辆型号
        fileHash: "", //文件hash
        fileName: "", //文件名称
        filePath: "", //文件路径
        fileSize: "", //文件大小
        hwType: "", //固件类别
        hwVersion: "", //适配硬件版本
        firmwareName: "", //固件名称
        fwVersion: "", //固件版本
        firmwareIntro: "", //固件说明
      },
      fileList: [],
      firmwareManagementListBikeType: [],
      firmwareManagementListSuitableHwVersion: [],
      title: this.$t("pages.equipment.text217"),
      rules: {
        firmwareName: [
          { validator: validateSpace, trigger: "blur" },
          {
            required: true,
            message: this.$t("pages.equipment.text218"), //请输入固件名称
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: this.$t("pages.equipment.text219"), //请输入32字以内，唯一不重复,支持大小写字母，数字，下划线等
            trigger: "blur",
          },
        ],
        bikeCategoryId: {
          required: true,
          message: this.$t("pages.equipment.text150"), //请选择车辆类别
          trigger: "change",
        },
        bikeTypeId: {
          required: true,
          message: this.$t("pages.equipment.text64"), //请选择车辆型号
          trigger: "change",
        },
        hwType: {
          required: true,
          message: this.$t("pages.equipment.text220"), //请选择固件类别
          trigger: "change",
        },
        hwVersion: {
          required: true,
          message: this.$t("pages.equipment.text221"), //请选择适配硬件版本
          trigger: "change",
        },
        fwVersion: [
           { validator: validateSpace, trigger: "blur" },
          {
            required: true,
            message: this.$t("config.text30"), //请输入版本号
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: this.$t("pages.equipment.text222"), //请填写固件版本，支持大小写字母，数字，下划线等
            trigger: "blur",
          },
        ],
        firmwareIntro: {
          required: true,
          message: this.$t("pages.equipment.text223"), //请填写固件说明，50字以内
          trigger: "blur",
        },
      },
    };
  },
  // 监听弹窗类型
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.dialogStatus == 1) {
          this.title = this.$t("pages.equipment.text225"); //编辑固件
        }
        if (this.dialogStatus == 2) {
          this.title = this.$t("pages.equipment.text226"); //查看固件
        }
        if (this.dialogStatus == 0) {
          this.title = this.$t("pages.equipment.text217"); //新增固件
        }
        if (this.dialogStatus != 0) {
          this.ruleForm = {
            belongCustomerId: this.currentAgreement.belongCustomerId, //客户id
            bikeCategoryId: this.currentAgreement.bikeCategoryId, //车辆类别
            bikeTypeId: this.currentAgreement.bikeTypeId, //车辆型号
            bikeTypeName: this.currentAgreement.bikeTypeName, //车辆型号名称
            fileHash: this.currentAgreement.fileHash, //文件hash
            fileName: this.currentAgreement.fileName, //文件名称
            filePath: this.currentAgreement.filePath, //文件路径
            fileSize: this.currentAgreement.fileSize, //文件大小
            hwType: this.currentAgreement.hwType, //固件类别
            hwVersion: this.currentAgreement.hwVersion, //适配硬件版本
            firmwareName: this.currentAgreement.firmwareName, //固件名称
            fwVersion: this.currentAgreement.fwVersion, //固件版本
            firmwareIntro: this.currentAgreement.firmwareIntro, //固件说明
            id: this.currentAgreement.id,
          };
          let arr = [];
          arr.push({
            url: this.currentAgreement.filePath,
            name: this.currentAgreement.fileName,
          });
          this.fileList = arr;
          this.firmwareManagementListAllBikeType();
          this.firmwareManagementListAllSuitableHwVersion();
        }
      }
    },
  },
  components: {
    DiliUploadFile,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: [
    "dialogVisible",
    "options",
    "opeting",
    "dialogStatus",
    "currentAgreement",
  ],
  methods: {
    //选择车辆类别
    selectBikeCategory() {
      this.ruleForm.bikeTypeId = null;
      this.ruleForm.hwType = null;
      this.ruleForm.hwVersion = null;
      this.firmwareManagementListSuitableHwVersion = [];
      this.firmwareManagementListAllBikeType();
    },
    //选择车辆型号
    selectBikeType() {
      this.ruleForm.hwType = null;
      this.ruleForm.hwVersion = null;
    },
    //选择固件类别
    selectHwType() {
      this.ruleForm.hwVersion = null;
      this.firmwareManagementListAllSuitableHwVersion();
    },
    //查询车辆型号（筛选）
    firmwareManagementListAllBikeType() {
      let str = "";
      str = "?bikeCategoryId=" + this.ruleForm.bikeCategoryId;
      this.request.firmwareManagementListAllBikeType(str).then((res) => {
        this.firmwareManagementListBikeType = res.data;
      });
    },
    //查询适配的硬件版本
    firmwareManagementListAllSuitableHwVersion() {
      let formData = {
        belongCustomerId: this.platformData.id,
        bikeCategoryId: this.ruleForm.bikeCategoryId,
        bikeTypeId: this.ruleForm.bikeTypeId,
        hwType: this.ruleForm.hwType,
      };
      this.request
        .firmwareManagementListAllSuitableHwVersion(formData)
        .then((res) => {
          this.firmwareManagementListSuitableHwVersion = res.data;
        });
    },
    //关闭弹窗
    handleClose() {
      this.ruleForm = {
        belongCustomerId: "", //客户id
        bikeCategoryId: "", //车辆类别
        bikeTypeId: "", //车辆型号
        bikeTypeName: "", //车辆型号名称
        fileHash: "", //文件hash
        fileName: "", //文件名称
        filePath: "", //文件路径
        fileSize: "", //文件大小
        hwType: "", //固件类别
        hwVersion: "", //适配硬件版本
        firmwareName: "", //固件名称
        fwVersion: "", //固件版本
        firmwareIntro: "", //固件说明
      };
      this.firmwareManagementListBikeType = [];
      this.firmwareManagementListSuitableHwVersion = [];
      this.fileList = [];
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    sizeReset(size) {
      return sizeReset(size);
    },
    //删除文件
    remove(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.fileHash = ""; //文件hash
      this.ruleForm.fileName = ""; //文件名称
      this.ruleForm.filePath = ""; //文件路径
      this.ruleForm.fileSize = ""; //文件大小
    },
    //文件上传成功
    success(e) {
      this.fileList = e.fileList;
      this.ruleForm.fileHash = e.hash; //文件hash
      this.ruleForm.fileName = e.name; //文件名称
      this.ruleForm.filePath = e.url; //文件路径
      this.ruleForm.fileSize = e.size; //文件大小
      this.$refs["ruleForm"].clearValidate();
    },
    //提交
    submit() {
      this.ruleForm.belongCustomerId = this.platformData.id;
      let that = this;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (that.ruleForm.filePath == "") {
            return that.$message.error(that.$t("pages.equipment.text224"));
          }
          if (that.dialogStatus == 0) {
            that.request.firmwareManagementAdd(that.ruleForm).then(() => {
              that.$emit("firmwareManagementList");
              that.$message.success(that.$t("pages.equipment.text227"));
              this.$emit("firmwareManagementList");
              that.handleClose();
            });
          } else {
            that.request.firmwareManagementEdit(that.ruleForm).then(() => {
              that.$emit("firmwareManagementList");
              that.$message.success(that.$t("pages.equipment.text228"));
              this.$emit("firmwareManagementList");
              that.handleClose();
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
.firmware-content {
  display: flex;
}
.firmware-content a {
  margin-right: 20px;
}
</style>